import React from 'react';
import { Header, Footer } from './components/Layout';
import { Hero } from './components/Hero';
import { TrustBar, ProblemSection, LogisticsTrapSection, PayoffSection, ProcessSection, TestimonialsSection, ComparisonSection, FinalCTASection, FAQSection } from './components/ContentSections';
import { Services } from './components/Services';
import { ServiceArea } from './components/ServiceArea';
import { BeforeAfter } from './components/BeforeAfter';
import { Gallery } from './components/Gallery';
import { PhotoQuote } from './components/PhotoQuote';
import { VideoSection } from './components/VideoSection';
import { FloatingActions } from './components/FloatingActions';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-zinc-50 font-sans text-brand-black selection:bg-brand-red selection:text-white antialiased" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <LogisticsTrapSection data-id="element-6" />
        <Services data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <PayoffSection data-id="element-9" />
        <PhotoQuote data-id="element-10" />
        <ProcessSection data-id="element-11" />
        <VideoSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <Gallery data-id="element-14" />
        <ServiceArea data-id="element-15" />
        <ComparisonSection data-id="element-16" />
        <FAQSection data-id="element-17" />
        <FinalCTASection data-id="element-18" />
      </main>

      <Footer data-id="element-19" />
      <FloatingActions data-id="element-20" />
    </div>;
}